<template>
  <transition name="fade">
    <div class="modal" v-if="show">
      <div class="overlay" v-on:click="close"></div>
      <div class="modalContent">
        <div class="close" v-on:click="close(false)"></div>
        <h4 class="modalTitle">{{contentTitle}}</h4>
        <!-- <p class="subtitle"></p> -->
        <div class="loading" v-if="loading"></div>
        <div class="noData" v-else-if="!results || results.length < 1">
          No Data Available
        </div>
        <div class="listingSc" v-else>
          <div class="listingCnt">
            <div class="listingInfo">
              <div class="page2Cnt">
                <div class="pageRank">
                  <div class="sources">
                    <div class="sourceItem" v-for="(item, i) in results" :key="i">
                      <div class="source">{{item.label}}<span v-if="item.timestamp"> //
                      {{item.timestamp | moment('ddd, D MMM YYYY')}}</span></div>
                      <div class="count" v-if="item.countType === 'time'">
                        {{item.count | moment('mm:ss')}}</div>
                      <div class="count" v-else>
                        {{item.count.toLocaleString('id')}}<span v-if="item.countLabel">
                        {{item.countLabel}}</span></div>
                      <div class="percentage" :style="`width: ${item.percentage}%;`"></div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="pagination">
          <div :class="{pn: true, prev: true, disabled: !isPage2}"
            v-on:click="isPage2 = false">Previous</div>
          <div :class="{pn: true, next: true, disabled: isPage2}"
            v-on:click="isPage2 = true">Next</div>
        </div>
        <div class="pager">
          <div :class="{p: true, active: !isPage2}"
            v-on:click="isPage2 = false"></div>
          <div :class="{p: true, active: isPage2}"
            v-on:click="isPage2 = true"></div>
        </div>
      </div>
    </div>
  </transition>
</template>

<script>
export default {
  data() {
    return {
      show: false,
      next: null,
      loading: true,
      contentTitle: '',
      detail: null,
      isPage2: false,
      timer: null,
      online: 0,
      results: [],
    };
  },
  methods: {
    open(d, n) {
      this.contentTitle = d.title;
      this.loading = true;
      this.show = true;
    },
    setData(results) {
      this.results = results;
      this.loading = false;
    },
    close(b) {
      this.show = false;
    },
  },
};
</script>

<style scoped lang="scss">
  .listingSc{
    width: auto;
    height: 68vh;
    overflow: auto;
    border-top: #eee 1px solid;
    margin: 10px -60px -50px;
    padding: 0 60px;
  }
  .listingCnt{
    position: relative;
    .listingInfo{
      width: 100%;
      transition: all .3s ease;
      &.page1{
        margin-left: -680px;
        &.active{
          margin-left: 0;
        }
      }
      .page2Cnt{
        .pageRank{
          box-sizing: border-box;
          &.ontop{
            padding-bottom: 30px;
          }
          &.onleft{
            padding-right: 15px;
          }
          &.onright{
            padding-left: 15px;
          }
          &.download{
            display: none;
          }
          h4{
            margin: 0;
            font-size: 20px;
          }
        }
      }
    }
  }
  .pagination{
    position: absolute;
    bottom: 16px; right: 40px;
    display: flex;
    display: none;
    .pn{
      font-size: 16px;
      color: #0057d8;
      font-weight: 600;
      padding: 4px 20px 6px;
      border-radius: 50px;
      position: relative;
      cursor: pointer;
      &:hover{
        background-color: #eee;
      }
      &:before{
        position: absolute;
        height: 100%; top: 0;
        content: "";
        width: 20px;
        background-size: 16px auto;
        background-position: center;
        background-repeat: no-repeat;
      }
      &.next{
        padding-right: 40px;
        &:before{
          right: 12px;
          background-image: url(../assets/next-arrow-blue.png);
        }
      }
      &.prev{
        padding-left: 40px;
        &:before{
          left: 12px;
          background-image: url(../assets/back-arrow-blue.png);
        }
      }
      &.disabled{
        color: #999;
        cursor: default;
        background-color: #fff;
        &:before{
          opacity: .4;
        }
        &.next{
          &:before{
            background-image: url(../assets/next-arrow-black.png);
          }
        }
        &.prev{
          &:before{
            background-image: url(../assets/back-arrow.png);
          }
        }
      }
    }
  }
  .pager{
    position: absolute;
    left: 50%; bottom: 26px;
    display: flex;
    transform: translateX(-50%);
    display: none;
    .p{
      width: 10px; height: 10px;
      background-color: #ccc;
      border-radius: 50%;
      margin: 0 5px;
      cursor: pointer;
      &:hover{
        background-color: #999;
      }
      &.active{
        background-color: #0e5dd2;
      }
    }
  }

  .modal{
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    z-index: 991;
    display: flex;
    align-items: center;
    justify-content: center;
    overflow: auto;
    padding: 40px 0;
    .overlay{
      position: fixed;
      top: 0;
      left: 0;
      right: 0;
      bottom: 0;
      background: rgba(0,0,0,.5);
      z-index: 1;
    }
    .modalContent{
      position: relative;
      z-index: 2;
      background: #fff;
      width: 460px;
      margin: auto;
      border-radius: 5px;
      padding: 40px 60px 50px;
      .loading{
        height: 400px;
        background-image: url(../assets/loading-2.svg);
        background-position: center;
        background-size: 46px auto;
        background-repeat: no-repeat;
      }
      .close{
        width: 36px;
        height: 36px;
        border-radius: 50%;
        background-image: url(../assets/close.png);
        background-size: 14px auto;
        background-position: center;
        background-repeat: no-repeat;
        position: absolute;
        right: 10px;
        top: 10px;
        opacity: .4;
        cursor: pointer;
        transition: all .2s linear;
      }
      .modalTitle{
        font-size: 28px;
        margin: 0;
      }
      .subtitle{
        margin: 0 0 20px;
        font-size: 18px;
        color: #767676;
      }
      .alHeader{
        display: flex;
        margin-bottom: 10px;
        .onlineVisitor{
          width: 240px;
          box-shadow: 2px 2px 4px rgba(0,0,0,.1);
          border-radius: 10px;
          text-align: center;
          padding: 30px 20px 0;
          box-sizing: border-box;
          min-height: 240px;
          h4{
            margin: 0;
            font-size: 20px;
          }
          h5{
            margin: 26px 0;
            font-size: 60px;
            font-weight: normal;
          }
          p{
            margin: 0;
            font-size: 14px;
            color: #767676;
          }
        }
        .pageRankCnt{
          width: calc(100% - 240px);
          display: flex;
          .pageRank{
            box-sizing: border-box;
            padding-left: 30px;
            width: 100%;
            // width: 50%;
            h4{
              margin: 0;
              font-size: 20px;
            }
          }
        }
      }
      .alBody{
        display: flex;
        .analyticContent{
          // width: calc(100% - 300px);
          width: 100%;
          // padding-right: 30px;
        }
        .pageRank{
          width: 300px;
          h4{
            margin: 0;
            font-size: 20px;
            padding-top: 20px;
          }
        }
      }
    }
  }
  .moreCnt{
    text-align: right;
    .moreBtn{
      color: #0057d8;
      font-weight: 600;
      position: relative;
      padding-right: 26px;
      cursor: pointer;
      display: inline-block;
      &:hover{
        color: #0067ff;
      }
      &:before{
        content: "";
        position: absolute;
        right: 0; top: 1px; bottom: 0; width: 16px;
        background-image: url(../assets/next-arrow-blue.png);
        background-size: contain;
        background-position: center;
        background-repeat: no-repeat;
      }
    }
  }
  .sources{
    margin-bottom: 20px;
    .sourceItem{
      padding: 16px 0 10px;
      display: flex;
      position: relative;
      .percentage{
        position: absolute;
        height: 4px;
        background-color: #0e5dd2;
        bottom: 0; left: 0;
        border-radius: 50px;
      }
      .source{
        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;
        margin-right: auto;
        span{
          color: #767676;
        }
      }
      .count{
        font-weight: 600;
        white-space: nowrap;
      }
    }
  }
  .analyticContent{
    padding-top: 20px;
    // margin-bottom: -30px;
    .analyticItem{
      font-size: 20px;
      font-weight: bold;
      margin-bottom: 20px;
      p{
        margin: 0;
        margin-top: 2px;
        font-size: 30px;
        float: right;
        font-weight: 600;
      }
      span{
        display: block;
        font-size: 14px;
        font-weight: normal;
        padding-right: 160px;
        color: #767676;
      }
    }
  }
</style>
